module.exports = __webpack_public_path__ + "img/NT3.822f6a7a.svg";